import { Box, Divider, Grid2, Paper, Typography } from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

export default function Section(props: any) {
  const { title, children, icon, sx, accordion, initOpen, iconAction } = props;
  const [open, setOpen] = useState(!accordion || (accordion && initOpen));
  const { t } = useTranslation();

  function HeaderIcon() {
    return accordion || icon ? (
      <Box
        onClick={() => {
          if (accordion) {
            setOpen(!open);
          } else {
            iconAction && iconAction();
          }
        }}
        sx={{
          ...(!open && { height: "1rem" }),
          ...(iconAction || accordion
            ? {
                "& > :hover": {
                  borderRadius: "5px",
                  color: "blue",
                  border: "2px solid blue",
                  cursor: "pointer",
                },
              }
            : {
                cursor: "default",
              }),
        }}
      >
        {accordion ? (
          <ExpandMoreIcon
            fontSize="large"
            sx={{ rotate: open ? "180deg" : "0deg" }}
          />
        ) : (
          icon
        )}
      </Box>
    ) : (
      <></>
    );
  }

  return (
    <Paper
      elevation={10}
      sx={{
        padding: "16px",
        height: "100%",
        ...sx,
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        {...(accordion && {
          sx: {
            cursor: "pointer",
          },
          onClick: () => {
            setOpen(!open);
          },
        })}
      >
        <Typography variant="h6" fontWeight={"bold"}>
          {t(`FORM.SECTION.${title}`)}
        </Typography>
        <HeaderIcon />
      </Box>
      {open && (
        <>
          <Divider
            sx={{
              borderColor: "black",
              marginTop: 0,
              marginBottom: 3,
            }}
          />
          <Grid2 container spacing={2}>
            {children}
          </Grid2>
        </>
      )}
    </Paper>
  );
}
